import { useContext } from "react";

import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import get from "@beeldit/core/services/get";
import { EditActionContext } from "./EditActionContext";
import { ChangeDectionContext } from "@beeldit/core/context/ChangeDectionContext";

function useGet(modelConfig: any) {
  const { setElement, setShowModal } = useContext(EditActionContext);
  const { setChanged } = useContext(ChangeDectionContext);
  const errorHandler = useErrorHandler();

  return (
    id: any,
    onSuccess: any = (data: any) => {
      return data;
    },
  ) => {
    get(modelConfig.endpoint, id, "?selector=edit")
      .then((response: any) => {
        let data = response.data;
        try {
          if (process.env.REACT_APP_DEBUG_MODE === "true") {
            // eslint-disable-next-line no-console
            console.log("[useGet] response.data", response.data);
          }
        } catch (e) {}
        data = onSuccess(response.data);
        setElement(data);
        setShowModal(true);
        setTimeout(() => {
          setChanged(false, response.data);
        }, 3000);
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useGet;
